import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const tourApi = createApi({
  reducerPath: "tourApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem("hthUser");
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTourList: builder.mutation({
      query: (payload) => ({
        url: "/api/tour/search",
        method: "POST",
        body: payload,
      }),
    }),
    addEditTourAvailability: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/addEditTourAvailability",
        method: "POST",
        body: payload,
      }),
    }),
    globalSearchTour: builder.mutation({
      query: (payload) => ({
        url: "/api/tour/globalSearch",
        method: "POST",
        body: payload,
      }),
    }),
    deleteTourAvailability: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/deleteTourAvailability",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const viewEditTourApi = createApi({
  reducerPath: "viewEditTourApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem("hthUser");
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTourDetails: builder.query({
      query: (tourLink) => ({
        url: `/api/tour/tour-details/${tourLink}`,
        method: "GET",
      }),
    }),
    getTourFilterList: builder.query({
      query: () => ({
        url: "/api/tour/filter-list",
        method: "GET",
      }),
    }),
    getTourArea: builder.query({
      query: () => ({
        url: "/api/admin/getTourArea",
        method: "GET",
      }),
    }),
    addEditBasicTour: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/addEditBasicTour",
        method: "POST",
        body: payload,
      }),
    }),
    addEditTourImage: builder.mutation({
      query: (formData) => ({
        url: "/api/admin/addEditTourImage",
        method: "POST",
        body: formData,
        formData: true,
      }),
    }),
    addEditTourDtls: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/addEditTourDtls",
        method: "POST",
        body: payload,
      }),
    }),
    addEditTourInstructions: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/addEditTourInstructions",
        method: "POST",
        body: payload,
      }),
    }),
    addEditTourDiscount: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/addEditTourDiscount",
        method: "POST",
        body: payload,
      }),
    }),
    deleteTour: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/deleteTour",
        method: "POST",
        body: payload,
      }),
    }),
    changeButton: builder.mutation({
      query: ({ tourId, value }) => ({
        url: `/api/admin/changeButton/${tourId}/${encodeURIComponent(value)}`,
        method: "GET",
      }),
    }),
    addTopVisitList: builder.mutation({
      query: ({ tourId, linkVal }) => ({
        url: `/api/admin/addTopVisitList/${tourId}/${linkVal}`,
        method: "GET",
      }),
    }),
    getTourPdf: builder.query({
      query: (tourId) => ({
        url: `/api/admin/getTourPdf/${tourId}`,
        method: "GET",
      }),
    }),
    addTourPdf: builder.mutation({
      query: (formData) => ({
        url: "/api/admin/addTourPdf",
        method: "POST",
        body: formData,
        formData: true,
      }),
    }),
    getMetaData: builder.query({
      query: (tourId) => ({
        url: `/api/admin/getMetaData/${tourId}`,
        method: "GET",
      }),
    }),
    addMetaData: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/addMetaData",
        method: "POST",
        body: payload,
      }),
    }),
    getTourImages: builder.query({
      query: (tourId) => ({
        url: `/api/admin/getTourTourImage/${tourId}`,
        method: "GET",
      }),
    }),
    deleteTourImage: builder.mutation({
      query: (imageId) => ({
        url: `/api/admin/deleteTourTourImage`,
        method: "POST",
        body: imageId,
      }),
    }),
    getTourAvailability: builder.query({
      query: (tourId) => ({
        url: `/api/admin/getTourAvailability/${tourId}`,
        method: "GET",
      }),
    }),
    getFaqList: builder.query({
      query: ({ faqId = 0, tourId = 0 }) => ({
        url: `/api/admin/faq/${faqId}/${tourId}`,
        method: "GET",
      }),
    }),
    addEditFaq: builder.mutation({
      query: (payload) => ({
        url: "/api/admin/addEditFaq",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useGetTourListMutation, useAddEditTourAvailabilityMutation, useGlobalSearchTourMutation, useDeleteTourAvailabilityMutation } = tourApi;

export const {
  useGetTourDetailsQuery,
  useGetTourFilterListQuery,
  useGetTourAreaQuery,
  useAddEditBasicTourMutation,
  useAddEditTourImageMutation,
  useAddEditTourDtlsMutation,
  useAddEditTourInstructionsMutation,
  useAddEditTourDiscountMutation,
  useDeleteTourMutation,
  useChangeButtonMutation,
  useAddTopVisitListMutation,
  useGetTourPdfQuery,
  useAddTourPdfMutation,
  useGetMetaDataQuery,
  useAddMetaDataMutation,
  useGetTourImagesQuery,
  useDeleteTourImageMutation,
  useGetTourAvailabilityQuery,
  useGetFaqListQuery,
  useAddEditFaqMutation,
} = viewEditTourApi;
